import { Injectable } from "@angular/core";
import { statusIconAndColor } from "@features/labeling/utils";
import { createCustomArtifact, PainterImage } from '@shared/models/painter';
import { PainterService } from "@shared/services/item-feed/image-feed/painter.service";
import { LabelingReviewCellData, ReviewStatus } from "./labeling-review.service";

@Injectable()
export class LabelingReviewImagePainterService extends PainterService {
    paintForFeed(cellData: LabelingReviewCellData, image: PainterImage): void {
        let {color, icon} = statusIconAndColor(cellData.status);
        
        const box = createCustomArtifact({
            backgroundColor: color,
            color: '#fff',
            fontSize: '16px',
            top: '8px',
            right: '8px',
            borderRadius: '20px',
            width: '24px',
            height: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        });
        box.icon = icon;
        image.addArtifact(box);
    }
}
